import { exit } from 'process';
import { Subscription } from 'rxjs';
import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Ricerca } from 'src/app/models/ricerca.model';
import { BookService } from 'src/app/services/book.service';
import { JsonapiService } from 'src/app/services/jsonapi.service';
import { MessageService } from 'src/app/services/message.service';
import { LocalStorageService } from 'src/app/services/storage.service';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import * as moment from 'moment';


@Component({
  selector: 'admin-catalogo',
  templateUrl: './catalogo.component.html',
  styleUrls: ['./catalogo.component.scss']
})
export class CatalogoComponent implements OnInit {
  public pagination = [];
  public book;
  public books: any = [];
  public booksPage: any = [];
  //info riguardanti la paginaziine degli oggetti restituiti es. current-page
  public booksMeta: any = {};
  public loader = false;
  public page = 1;
  public search = '';
  public searchField = 'titolo';
  public defaultOrder = 'data_pubblicazione';
  public sortField = '-data_pubblicazione';
  public option = 'view';
  searchFilters: any = {};
  filters = [];
  salvaModifiche = false;
  flip: string = 'default';
  public stati = [
      { cod: 'P' , descrizione:  'Disponibile'},
      { cod: 'E' , descrizione: 'Esaurito' },
      { cod: 'R' , descrizione: 'Ristampa'},
      { cod: 'I' , descrizione: 'In produzione'}
  ];
    animation = '';
    public links = [];
    searchCtrl = new FormControl();
    subscribe: Subscription;
    ricerca: Ricerca = {
        fields: [
            {
                field: 'editore',
                option: {
                    type: 'lazyUrl',
                    lazyUrl: 'editore',
                }
            },
            {
                field: 'titolo',
                option: {
                    type: 'text',
                }
            },
            {
                field: 'ean',
                option: {
                    type: 'text',
                }
            },
            {
                field: 'anno_pubblicazione',
                option: {
                    type: 'text',
                }
            },
            {
                field: 'autore',
                option: {
                    type: 'lazyUrl',
                    lazyUrl: 'autore',
                }
            },
            {
                field: 'collana',
                option: {
                    type: 'lazyUrl',
                    lazyUrl: 'collana',
                }
            },
            {
                field: 'argomento',
                option: {
                    type: 'lazyUrl',
                    lazyUrl: 'argomento',
                }
            },
            {
                field: 'stato',
                option: {
                    type: 'select',
                    list: []
                }
            }
        ],
    };

  selectedBook = null;
  catalogoloaded = null;
  submit:boolean = false;
  @Output() loaded = new EventEmitter();
 
  public exporting = false;
  public soloDisponibili = false;
  /** Toggle "Stampa": indica al BE se includere la disponibilità nel PDF/Excel esportato */
  public stampaDisponibilita = true;

  constructor(
      private jsonapi: JsonapiService,
      private storage: LocalStorageService,
      private messageservice: MessageService,
      private bookservice: BookService,
      private toastservice: ToastrService,
  ) {
      this.searchCtrl.valueChanges.subscribe((data: string) => {
          this.search = data;
          //this.getBooks(0);
      });
      
  } 
    ngOnInit(): void {
        this.buildStatiList();
    }
  /**prendo tutti i libri presenti nel catalogo dal database */
    getAllBooks(page, sort?, filters?){
        this.loader = true;
        this.subscribe = this.jsonapi.getCollectionPaginated('catalogo-generales', page,20,filters, sort).subscribe((data:any) => {
            this.loader = false;
            this.books = data.data;
            this.booksMeta = data.meta.page;
            this.booksPage = data.data;
            this.searchFilters = {};
        }, (error: any) => {
            this.loader = false;
            console.log(error);
        });
    }

    /* ngOnDestroy(): void {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subscribe.unsubscribe();
    } */

    toggle(bookId): void {
        this.selectedBook = !bookId ? null : bookId
        this.option = 'view';
        this.salvaModifiche = false;
    }


    getSearchType(data: any) { 
        if (data.event === 'search' ) { 
            this.searchFilters = data.values;
        }
        if(data.event === 'order'){
           this.sortField = (data.value === 'desc')? '-'+data.field : data.field;
        }   
    }

    submitButton(){
        this.filters = this.searchFilters;
        console.log(this.searchFilters);
        this.getAllBooks(1, this.sortField, this.buildFilters());
      }

    /**Filtri di ricerca correnti più, se attivo, il filtro "solo disponibili"*/
    buildFilters(): any[] {
        const filters = this.filters && this.filters.length > 0 ? [...this.filters] : [];
        if (this.soloDisponibili) {
            filters.push({ name: 'disponibile', value: '1' });
        }
        return filters;
    }

    /**Imposta lo stato del filtro "mostra solo libri disponibili": la ricerca riparte
     * solo al click su "Cerca" (submitButton), non appena si tocca il toggle.*/
    toggleDisponibili(event: any): void {
        this.soloDisponibili = event.checked;
    }

    /**Imposta se il PDF/Excel esportato deve includere la disponibilità: riguarda solo
     * l'export, non la ricerca a schermo, quindi non serve rilanciare nulla qui.*/
    toggleStampa(event: any): void {
        this.stampaDisponibilita = event.checked;
    }

    modifica() {
        this.option = 'edit';
    }
    confirm() { 
        this.salvaModifiche = true;
    }

    changePage($event): void {
        this.page = $event.pageIndex+1;
        this.getAllBooks(this.page, this.sortField, this.buildFilters());
        this.loader = true;
    }
    resetForm(event){
        if(event){
            this.filters = [];
            this.soloDisponibili = false;
        }
    }


    getStato(codstato){
        const stato = this.stati.find((s) => s.cod === codstato);
        // Il catalogo ha codici stato (es. "C", "V", "#", "+") non presenti in questa
        // lista fissa: senza fallback, un libro con uno di questi codici mandava in
        // crash il rendering dell'intera pagina dei risultati.
        return stato ? stato.descrizione : (codstato || 'N.D.');
    }

    buildStatiList() {
        const i = _.findIndex(this.ricerca.fields, {field : 'stato'});
        this.ricerca.fields[i].option.list = this.stati;
    }
    /**Esporta in PDF/Excel tutti i libri che corrispondono ai filtri di ricerca correnti*/
    exportCatalogo(format: 'pdf' | 'xlsx'): void {
        this.exporting = true;
        this.bookservice.exportCatalogo(format, this.buildFilters(), this.sortField, this.stampaDisponibilita).subscribe({
            next: (data: Blob) => {
                this.exporting = false;
                const contentType = format === 'pdf'
                    ? 'application/pdf'
                    : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                const blob = new Blob([data], { type: contentType });
                const a = document.createElement('a');
                a.href = URL.createObjectURL(blob);
                a.download = `catalogo_export.${format}`;
                a.click();
            },
            error: (err: any) => {
                this.exporting = false;
                if (err.error instanceof Blob) {
                    err.error.text().then((text: string) => {
                        let message = 'Esportazione non riuscita.';
                        try {
                            message = JSON.parse(text).message || message;
                        } catch (e) { }
                        this.toastservice.error(message);
                    });
                } else {
                    this.toastservice.error('Esportazione non riuscita.');
                }
            }
        });
    }

    /**Esegue la ricerca al click dell'elemento nella card del libro*/
    searchFromBook(field, value){
        const filtro = [{name:field, value:value}];
        if (this.soloDisponibili) {
            filtro.push({ name: 'disponibile', value: '1' });
        }
        this.getAllBooks(1,this.sortField,filtro);
    }

    formatData(data) {
        return moment(data, 'YYYYMMDD').format('DD-MM-YYYY');
    }
}
